import { ref } from 'vue';

export interface Notification {
  id: string;
  type?: 'error' | 'warning' | 'success';
  title?: string;
  details?: string;
  size?: 'm' | 's';
  message?: string;
  autoClose?: boolean;
  duration?: number;
}

export type CreateNotification = {
  (options: {
    type?: 'error' | 'warning' | 'success';
    title?: string;
    details?: string;
    size?: 'm' | 's';
    message?: string;
    autoClose?: boolean;
    duration?: number;
  }): void;
};

function createUUID(): string {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

const defaultNotificationOptions = {
  type: 'info',
  title: 'Info Notification',
  message: 'Ooops! A message was not provided.',
  autoClose: true,
};

export default function useNotifications() {
  // Reactive array of notifications.
  const notifications = ref<Notification[]>([]);

  // function to create notification
  const createNotification: CreateNotification = options => {
    const _options = Object.assign({ ...defaultNotificationOptions }, options);
    notifications.value.push(
      ...[
        {
          id: createUUID(),
          ..._options,
        },
      ]
    );
  };

  // function to remove notification
  const removeNotifications = (id: string) => {
    const index = notifications.value.findIndex(item => item.id === id);
    if (index !== -1) notifications.value.splice(index, 1);
  };

  // The two functions below are more for body
  // overflow when creating notifications that slide
  // in from outside the viewport. We will not be
  // using them for now but good to have.
  const stopBodyOverflow = () => {
    document && document.body.classList.add(...['hide-overflow']);
  };

  const allowBodyOverflow = () => {
    document && document.body.classList.remove(...['hide-overflow']);
  };

  // You need this to ensure we can use the
  // composition function.
  return {
    notifications,
    createNotification,
    removeNotifications,
    stopBodyOverflow,
    allowBodyOverflow,
  };
}
